/**
 * Dual B2C + B2B Shopping Experience Switcher & Integrations
 * Antigravity Coding Assistant
 */

document.addEventListener('DOMContentLoaded', () => {
  initShoppingExperience();
});

function initShoppingExperience() {
  const config = window.B2BConfig || {
    mode: localStorage.getItem('shopping_experience') || 'retail',
    defaultMode: 'retail',
    loaderDuration: 2000,
    enableB2B: true,
    enableSwitcher: true,
    bundleBuyButtonText: 'Buy Now'
  };

  // If B2B is disabled globally, force retail mode
  if (!config.enableB2B) {
    localStorage.setItem('shopping_experience', 'retail');
    document.cookie = "shopping_experience=retail; path=/; max-age=31536000";
    document.documentElement.className = document.documentElement.className.replace(/shopping-mode--\w+/, '') + ' shopping-mode--retail';
    return;
  }

  const activeMode = localStorage.getItem('shopping_experience') || config.defaultMode;
  
  // Set initial cookies/storage if not set
  if (!localStorage.getItem('shopping_experience')) {
    localStorage.setItem('shopping_experience', activeMode);
    document.cookie = `shopping_experience=${activeMode}; path=/; max-age=31536000`;
    
    // First-time onboarding: open the modal automatically to choose experience
    setTimeout(() => {
      openExperienceModal();
    }, 800);
  }

  // Bind elements
  bindSwitcherElements();
  bindModalElements();
  
  // If B2B is active, initialize B2B product page and cart hooks
  if (activeMode === 'business') {
    initBusinessModeFeatures(config);
  } else {
    initRetailModeFeatures();
  }

  // Universal Cart Subtotals and Savings hooks
  initCartPriceWatcher(activeMode);
}

/**
 * Bind header switcher button actions
 */
function bindSwitcherElements() {
  const switchers = document.querySelectorAll('[data-shopping-mode-switcher]');
  switchers.forEach(switcher => {
    // Show active states
    const activeMode = localStorage.getItem('shopping_experience') || 'retail';
    const retailBtn = switcher.querySelector('[data-mode-btn="retail"]');
    const businessBtn = switcher.querySelector('[data-mode-btn="business"]');

    if (retailBtn && activeMode === 'retail') retailBtn.classList.add('is-active');
    if (businessBtn && activeMode === 'business') businessBtn.classList.add('is-active');

    // Clicking either switcher button opens the experience selection modal
    retailBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      openExperienceModal();
    });
    
    businessBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      openExperienceModal();
    });
  });
}

/**
 * Modal visibility and option selection bindings
 */
function bindModalElements() {
  const modal = document.getElementById('ShoppingModeModal');
  const closeBtn = document.getElementById('ShoppingModalClose');
  const retailBtn = document.querySelector('[data-select-mode="retail"]');
  const businessBtn = document.querySelector('[data-select-mode="business"]');
  const retailCard = document.querySelector('[data-card-experience="retail"]');
  const businessCard = document.querySelector('[data-card-experience="business"]');

  if (!modal) return;

  // Highlight currently active card in the modal
  const activeMode = localStorage.getItem('shopping_experience') || 'retail';
  if (activeMode === 'retail' && retailCard) retailCard.classList.add('is-active');
  if (activeMode === 'business' && businessCard) businessCard.classList.add('is-active');

  const closeModal = () => {
    modal.style.display = 'none';
    document.body.style.overflow = '';
  };

  closeBtn?.addEventListener('click', closeModal);
  modal.addEventListener('click', (e) => {
    if (e.target === modal) closeModal();
  });

  // Handle choice selections
  retailBtn?.addEventListener('click', () => {
    switchShoppingMode('retail');
  });

  businessBtn?.addEventListener('click', () => {
    switchShoppingMode('business');
  });
}

function openExperienceModal() {
  const modal = document.getElementById('ShoppingModeModal');
  if (modal) {
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }
}

/**
 * Handle mode transitions with a premium 2s loading animation screen
 */
function switchShoppingMode(mode) {
  const config = window.B2BConfig || { loaderDuration: 2000 };
  const modal = document.getElementById('ShoppingModeModal');
  const loader = document.getElementById('ShoppingLoader');

  // Hide modal
  if (modal) modal.style.display = 'none';

  // Show loader overlay
  if (loader) {
    loader.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }

  // Persist mode
  localStorage.setItem('shopping_experience', mode);
  document.cookie = `shopping_experience=${mode}; path=/; max-age=31536000; secure; samesite=lax`;

  // Apply html element class
  document.documentElement.className = document.documentElement.className.replace(/shopping-mode--\w+/, '') + ' shopping-mode--' + mode;

  // Transition delay
  setTimeout(() => {
    window.location.reload();
  }, config.loaderDuration);
}

/**
 * Initialize Business Mode features on Product Pages
 */
function initBusinessModeFeatures(config) {
  // Show business elements in DOM
  document.querySelectorAll('.business-only').forEach(el => {
    if (el.tagName === 'DIV' || el.tagName === 'SPAN') {
      el.style.display = 'block';
    } else {
      el.style.display = '';
    }
  });
  
  // Hide retail-only elements
  document.querySelectorAll('.retail-only').forEach(el => el.style.display = 'none');

  // Handle B2B quantity selection and validations
  const qtyWrapper = document.querySelector('.product-quantity.business-only');
  if (qtyWrapper) {
    const qtyInput = qtyWrapper.querySelector('.b2b-qty-input');
    const warningMsg = qtyWrapper.querySelector('.b2b-moq-warning');
    const form = document.querySelector('form[data-type="add-to-cart-form"]');
    
    // Disable retail quantity input name, enable business quantity input name
    const retailQtyInput = document.querySelector('.product-quantity.retail-only .quantity-input');
    if (retailQtyInput) retailQtyInput.removeAttribute('name');
    if (qtyInput) qtyInput.setAttribute('name', 'quantity');

    if (qtyInput) {
      const moq = parseInt(qtyInput.min) || 5;

      // Real-time validations
      qtyInput.addEventListener('change', () => {
        const val = parseInt(qtyInput.value) || moq;
        if (val < moq) {
          qtyInput.value = moq;
          if (warningMsg) warningMsg.style.display = 'block';
        } else {
          if (warningMsg) warningMsg.style.display = 'none';
        }
      });
    }
  }

  // Load dynamic wholesale bundle discounts from the Bundler App
  loadWholesaleBundlerDiscounts(config);
}

/**
 * Initialize Retail Mode features on Product Pages
 */
function initRetailModeFeatures() {
  document.querySelectorAll('.retail-only').forEach(el => {
    if (el.tagName === 'DIV' || el.tagName === 'SPAN') {
      el.style.display = 'block';
    } else {
      el.style.display = '';
    }
  });
  
  document.querySelectorAll('.business-only').forEach(el => el.style.display = 'none');
  
  // Ensure retail quantity input has the active submit name
  const retailQtyInput = document.querySelector('.product-quantity.retail-only .quantity-input');
  const businessQtyInput = document.querySelector('.product-quantity.business-only .b2b-qty-input');
  
  if (businessQtyInput) businessQtyInput.removeAttribute('name');
  if (retailQtyInput) retailQtyInput.setAttribute('name', 'quantity');
}

/**
 * Fetch volume discount bundle data from the Bundler App
 */
function loadWholesaleBundlerDiscounts(config) {
  const container = document.getElementById('B2B-Bundle-Pricing-Container');
  const wrapper = document.querySelector('.business-bundle-pricing-wrapper');
  if (!container || !wrapper) return;

  const currentProductId = wrapper.dataset.b2bProductId;
  const currentVariantId = wrapper.dataset.b2bVariantId;
  const variantPrice = parseFloat(wrapper.dataset.b2bVariantPrice) / 100.0; // Variant price in Rupees

  console.log("[B2B Debug] Initializing wholesale discounts check for Product:", currentProductId, "Variant:", currentVariantId);

  let pollingTries = 0;

  const fetchTiers = () => {
    let allBundles = [];
    let source = "";

    // 1. Try to fetch bundles config via window.bndlr API
    if (typeof window.bndlr !== 'undefined' && typeof window.bndlr.getBundles === 'function') {
      allBundles = window.bndlr.getBundles();
      source = "window.bndlr.getBundles()";
    }
    
    // 2. Scan window for other possible variables if first step returned nothing
    if (!allBundles || allBundles.length === 0) {
      for (let key in window) {
        if (key !== 'B2BConfig' && (key.toLowerCase().includes('bundler') || key.toLowerCase().includes('bndlr'))) {
          const val = window[key];
          if (Array.isArray(val) && val.length > 0) {
            allBundles = val;
            source = `window.${key} (Array)`;
            break;
          } else if (val && typeof val === 'object') {
            if (Array.isArray(val.bundles) && val.bundles.length > 0) {
              allBundles = val.bundles;
              source = `window.${key}.bundles`;
              break;
            } else if (Array.isArray(val.volume_discounts) && val.volume_discounts.length > 0) {
              allBundles = val.volume_discounts;
              source = `window.${key}.volume_discounts`;
              break;
            }
          }
        }
      }
    }

    if (allBundles && allBundles.length > 0) {
      console.log(`[B2B Debug] Found ${allBundles.length} bundles from ${source}`);
      const volDiscounts = parseBundlerVolumeDiscounts(allBundles, currentProductId, currentVariantId);
      if (volDiscounts && volDiscounts.length > 0) {
        console.log("[B2B Debug] Successfully matched volume tiers:", volDiscounts);
        renderCustomWholesaleTiers(volDiscounts, variantPrice, config);
        return true;
      } else {
        console.log("[B2B Debug] No matching volume discount tiers found in config for product ID:", currentProductId);
      }
    }

    // 3. Fallback: Parse the default Bundler widget DOM structure if it has rendered in background
    const defaultWidget = document.querySelector('.bundler-target-element, .bundler-target-element-volume-discounts, [class*="bundler-target"]');
    if (defaultWidget && defaultWidget.children.length > 0) {
      console.log("[B2B Debug] Default widget container found with contents. Attempting DOM parse...");
      const parsedTiers = parseBundlerDOMTiers(defaultWidget, variantPrice);
      if (parsedTiers && parsedTiers.length > 0) {
        console.log("[B2B Debug] Successfully parsed DOM tiers:", parsedTiers);
        renderCustomWholesaleTiers(parsedTiers, variantPrice, config);
        return true;
      }
    }

    return false;
  };

  // Run immediately
  if (fetchTiers()) return;

  // Setup event listeners
  document.addEventListener('bundler:loaded', () => {
    console.log("[B2B Debug] Event: bundler:loaded triggered");
    fetchTiers();
  });
  document.addEventListener('bundler:bundle_widget_created', () => {
    console.log("[B2B Debug] Event: bundler:bundle_widget_created triggered");
    fetchTiers();
  });

  // Setup backup polling in case script is async loaded
  const interval = setInterval(() => {
    pollingTries++;
    const success = fetchTiers();
    
    if (success) {
      clearInterval(interval);
    } else if (pollingTries > 30) {
      clearInterval(interval);
      console.log("[B2B Debug] Polling finished. No bundles could be resolved for product.");
      
      // If we couldn't load any tiers after 6s, hide the placeholder
      if (container.querySelector('.bundle-pricing-loader-placeholder')) {
        wrapper.style.display = 'none';
      }
    }
  }, 200);
}

/**
 * Parse window.bndlr.getBundles() output
 */
function parseBundlerVolumeDiscounts(bundles, productId, variantId) {
  const tiers = [];
  
  bundles.forEach((bundle, idx) => {
    // Check if volume discount bundle
    const isVolume = bundle.type === 'volume_discount' || 
                     bundle.volume_discount || 
                     bundle.type === 'quantity_breaks' ||
                     (bundle.title && bundle.title.toLowerCase().includes('bulk')) ||
                     (bundle.title && bundle.title.toLowerCase().includes('discount'));
    
    // Check if this bundle applies to our product/variant
    let appliesToProduct = false;
    if (bundle.products && Array.isArray(bundle.products)) {
      appliesToProduct = bundle.products.some(p => 
        p.id == productId || 
        p.product_id == productId || 
        (p.variants && p.variants.some(v => v.product_id == productId || v.id == variantId || v.variant_id == variantId))
      );
    }
    
    if (!appliesToProduct && bundle.product_ids && Array.isArray(bundle.product_ids)) {
      appliesToProduct = bundle.product_ids.some(id => id == productId);
    }
    
    if (!appliesToProduct && bundle.variants && Array.isArray(bundle.variants)) {
      appliesToProduct = bundle.variants.some(v => v.product_id == productId || v.id == variantId || v.variant_id == variantId);
    }
    
    if (!appliesToProduct && bundle.variant_ids && Array.isArray(bundle.variant_ids)) {
      appliesToProduct = bundle.variant_ids.some(id => id == variantId);
    }

    // Default to true if the bundle doesn't specify restrictions (e.g. storewide discount)
    if (!appliesToProduct && !bundle.products && !bundle.product_ids && !bundle.variants && !bundle.variant_ids) {
      appliesToProduct = true;
    }

    console.log(`[B2B Debug] Bundle ${idx + 1} ("${bundle.title || 'Untitled'}"): isVolume=${isVolume}, appliesToProduct=${appliesToProduct}`);

    if (isVolume && appliesToProduct) {
      // Extract tiers
      const levels = bundle.levels || bundle.discounts || bundle.rules || bundle.tiers || bundle.quantity_breaks;
      if (levels && Array.isArray(levels)) {
        levels.forEach(lvl => {
          const qty = lvl.quantity || lvl.min_quantity || lvl.qty || lvl.min_qty || lvl.limit;
          const val = lvl.discount_value || lvl.value || lvl.discount || lvl.percent || lvl.amount || lvl.discount_percent;
          const type = lvl.discount_type || lvl.type || 'percent'; // percent or fixed
          
          if (qty && val) {
            tiers.push({
              quantity: parseInt(qty),
              discountValue: parseFloat(val),
              discountType: type,
              label: lvl.label || `Buy ${qty}`
            });
          }
        });
      }
    }
  });

  // Sort tiers by quantity ascending
  return tiers.sort((a, b) => a.quantity - b.quantity);
}

/**
 * Parse standard Bundler Widget DOM fallback
 */
function parseBundlerDOMTiers(widget, variantPrice) {
  const tiers = [];
  
  // Select typical bundler elements like table rows or list items or cards
  const rows = widget.querySelectorAll('.bndlr-tier, .bndlr-volume-discount-row, tr, [class*="tier"], [class*="discount-row"]');
  
  rows.forEach(row => {
    const text = row.textContent || "";
    
    // Extemely permissive regex matching:
    // Quantity: Matches "Buy 10", "10 or more", "10 units"
    const qtyMatch = text.match(/(?:buy|qty|quantity)\s*(\d+)/i) || 
                     text.match(/(\d+)\s*(?:units?|pcs?|or\s+more)/i) ||
                     text.match(/\b(\d+)\b/); // Fallback to first integer
                     
    // Percent: Matches "15%", "15 %", "Save 15"
    const discountMatch = text.match(/(\d+)\s*%/i) || 
                          text.match(/save\s*(\d+)/i);
    
    if (qtyMatch && discountMatch) {
      const qty = parseInt(qtyMatch[1]);
      const percent = parseFloat(discountMatch[1]);
      
      // Basic validation: quantity should be sensible (e.g. > 1) and discount < 100
      if (qty > 1 && percent > 0 && percent < 100) {
        tiers.push({
          quantity: qty,
          discountValue: percent,
          discountType: 'percent',
          label: `Buy ${qty}`
        });
      }
    }
  });
  
  // If list rows failed, scan text blocks or columns
  if (tiers.length === 0) {
    const textContent = widget.textContent || "";
    // Match patterns like "Buy 10... Save 15%"
    const matches = textContent.matchAll(/(?:buy|qty)\s*(\d+)[^%]*?(\d+)\s*%/gi);
    for (const match of matches) {
      const qty = parseInt(match[1]);
      const percent = parseFloat(match[2]);
      if (qty > 1 && percent > 0 && percent < 100) {
        tiers.push({
          quantity: qty,
          discountValue: percent,
          discountType: 'percent',
          label: `Buy ${qty}`
        });
      }
    }
  }

  // Remove duplicates and sort
  const uniqueTiers = [];
  const seenQties = new Set();
  tiers.forEach(t => {
    if (!seenQties.has(t.quantity)) {
      seenQties.add(t.quantity);
      uniqueTiers.push(t);
    }
  });
  
  return uniqueTiers.sort((a, b) => a.quantity - b.quantity);
};

/**
 * Render premium bulk pricing cards
 */
function renderCustomWholesaleTiers(tiers, variantPrice, config) {
  const container = document.getElementById('B2B-Bundle-Pricing-Container');
  const wrapper = document.querySelector('.business-bundle-pricing-wrapper');
  if (!container || !wrapper) return;

  // Clear loader
  container.innerHTML = '';
  wrapper.style.display = 'block'; // Make section visible

  // Render cards
  tiers.forEach(tier => {
    const qty = tier.quantity;
    const discountVal = tier.discountValue;
    const discountType = tier.discountType;

    // Calculate discounted unit price and totals
    let unitPrice = variantPrice;
    if (discountType === 'percent' || discountType.includes('percent')) {
      unitPrice = variantPrice * (1.0 - (discountVal / 100.0));
    } else {
      // Fixed amount discount off unit price
      unitPrice = variantPrice - discountVal;
    }

    const totalOriginal = variantPrice * qty;
    const totalDiscounted = unitPrice * qty;
    const totalSavings = totalOriginal - totalDiscounted;

    // Formatted strings
    const fmtOriginalTotal = formatCurrency(totalOriginal);
    const fmtDiscountedTotal = formatCurrency(totalDiscounted);
    const fmtDiscountPercent = discountType === 'percent' ? `${discountVal}%` : `${Math.round((totalSavings / totalOriginal) * 100)}%`;

    const card = document.createElement('div');
    card.className = 'bundle-tier-card bundle-tier-card--business-color';
    card.innerHTML = `
      <div class="bundle-tier-info">
        <div class="bundle-tier-title">Buy ${qty} Units</div>
        <div class="bundle-tier-prices">
          <span class="bundle-tier-price--original">${fmtOriginalTotal}</span>
          <span class="bundle-tier-price--discounted">${fmtDiscountedTotal}</span>
        </div>
      </div>
      
      <div style="display: flex; align-items: center; gap: 12px;">
        <span class="bundle-tier-badge">Save ${fmtDiscountPercent}!</span>
        <div class="bundle-tier-action">
          <button class="bundle-tier-btn" data-buy-qty="${qty}">
            ${config.bundleBuyButtonText || 'Buy Now'}
          </button>
        </div>
      </div>
    `;

    // Handle Buy Now clicks on bulk discounts
    const buyBtn = card.querySelector('[data-buy-qty]');
    buyBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      addBulkBundleToCart(qty, buyBtn);
    });

    container.appendChild(card);
  });
}

/**
 * Add specified quantity of active product variant to Shopify Cart via AJAX
 */
function addBulkBundleToCart(quantity, buttonElement) {
  const form = document.querySelector('form[data-type="add-to-cart-form"]');
  if (!form) return;

  const variantIdInput = form.querySelector('input[name="id"]');
  const variantId = variantIdInput ? variantIdInput.value : null;

  if (!variantId) {
    console.error("Active Variant ID not found");
    return;
  }

  // Show loading indicator on button
  const originalText = buttonElement.textContent;
  buttonElement.textContent = 'Adding...';
  buttonElement.disabled = true;

  // Formulate AJAX request
  const formData = {
    items: [{
      id: parseInt(variantId),
      quantity: parseInt(quantity)
    }]
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .then(data => {
    buttonElement.textContent = 'Added!';
    
    // Update discounts in Bundler and refresh cart drawer
    setTimeout(() => {
      buttonElement.textContent = originalText;
      buttonElement.disabled = false;
      
      // Open cart drawer and fetch updated content
      openCartDrawer();
      refreshCartDrawer();
    }, 800);
  })
  .catch(error => {
    console.error('Error adding bundle to cart:', error);
    buttonElement.textContent = 'Error';
    setTimeout(() => {
      buttonElement.textContent = originalText;
      buttonElement.disabled = false;
    }, 1500);
  });
}

/**
 * Helper to open theme cart drawer
 */
function openCartDrawer() {
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartOverlay = document.querySelector('[data-cart-overlay]');
  if (cartDrawer && cartOverlay) {
    cartDrawer.classList.add('active');
    cartOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
}

/**
 * Refreshes cart drawer items using section parsing
 */
function refreshCartDrawer() {
  fetch(window.location.href)
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Update cart drawer items
      const oldItems = document.querySelector('[data-cart-items-container]');
      const newItems = doc.querySelector('[data-cart-items-container]');
      if (oldItems && newItems) oldItems.innerHTML = newItems.innerHTML;
      
      // Update cart footer subtotals/gst notice
      const oldFooter = document.querySelector('.cart-drawer__footer');
      const newFooter = doc.querySelector('.cart-drawer__footer');
      if (oldFooter && newFooter) oldFooter.innerHTML = newFooter.innerHTML;
      
      // Update bubbles
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        const newCount = doc.querySelector('[data-cart-count]');
        if (newCount) el.textContent = newCount.textContent;
      });

      // Update cart page elements if we are on cart page
      const oldCartPage = document.querySelector('.cart-row');
      const newCartPage = doc.querySelector('.cart-row');
      if (oldCartPage && newCartPage) oldCartPage.innerHTML = newCartPage.innerHTML;

      // Re-initialize event listener bindings in the loaded drawer
      bindCartDrawerEvents();
      
      // Apply active B2B layouts
      const activeMode = localStorage.getItem('shopping_experience') || 'retail';
      if (activeMode === 'business') {
        document.querySelectorAll('.cart-b2b-badge, .cart-gst-notice, .cart-drawer__subtotals .business-only, .cart-item-row .business-only').forEach(el => {
          el.style.display = 'block';
        });
        document.querySelectorAll('.cart-drawer__subtotals .retail-only, .cart-item-row .retail-only').forEach(el => {
          el.style.display = 'none';
        });
      }

      // Re-trigger Bundler to update prices and fetch discount totals
      if (window.bndlr && typeof window.bndlr.updateCartDiscounts === 'function') {
        window.bndlr.updateCartDiscounts();
      }
    });
}

/**
 * Bind standard actions like Close and Gift Toggle inside parsed Cart Drawer
 */
function bindCartDrawerEvents() {
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartOverlay = document.querySelector('[data-cart-overlay]');
  const cartClose = document.querySelector('[data-cart-close]');
  
  const closeDrawer = () => {
    if (cartDrawer) cartDrawer.classList.remove('active');
    if (cartOverlay) cartOverlay.classList.remove('active');
    document.body.style.overflow = '';
  };

  if (cartClose) cartClose.addEventListener('click', closeDrawer);
  if (cartOverlay) cartOverlay.addEventListener('click', closeDrawer);

  // Gift note toggle
  const toggle = document.getElementById('CartGiftNoteToggle');
  const wrapper = document.getElementById('CartGiftNoteWrapper');
  if (toggle && wrapper) {
    toggle.addEventListener('change', () => {
      wrapper.style.display = toggle.checked ? 'block' : 'none';
    });
  }
}

/**
 * Dynamic Cart Watcher: Listen to Bundler calculations and display wholesale subtotals & savings
 */
function initCartPriceWatcher(activeMode) {
  // If in Business mode, apply dynamic styles to Cart elements
  if (activeMode === 'business') {
    document.querySelectorAll('.cart-b2b-badge, .cart-gst-notice, .cart-drawer__subtotals .business-only, .cart-item-row .business-only').forEach(el => {
      el.style.display = 'block';
    });
    document.querySelectorAll('.cart-drawer__subtotals .retail-only, .cart-item-row .retail-only').forEach(el => {
      el.style.display = 'none';
    });
  }

  // Listen to Bundler calculations event
  document.addEventListener('bundler:total_cart_values', (e) => {
    if (activeMode !== 'business') return;

    const detail = e.detail;
    if (!detail) return;

    const originalCents = parseFloat(detail.total_amount_original);
    const discountedCents = parseFloat(detail.total_amount_discounted);
    const savingsCents = parseFloat(detail.discount_amount);

    if (savingsCents > 0) {
      // 1. Update subtotal and savings rows
      document.querySelectorAll('[data-cart-original-subtotal]').forEach(el => {
        el.textContent = formatCurrency(originalCents / 100);
      });
      document.querySelectorAll('.cart-subtotal-row--original').forEach(el => el.style.display = 'flex');

      document.querySelectorAll('[data-cart-savings]').forEach(el => {
        el.textContent = `-${formatCurrency(savingsCents / 100)}`;
      });
      document.querySelectorAll('.cart-subtotal-row--savings').forEach(el => el.style.display = 'flex');

      document.querySelectorAll('[data-cart-final-subtotal], [data-cart-wholesale-subtotal]').forEach(el => {
        el.textContent = formatCurrency(discountedCents / 100);
      });
    }

    // 2. Fetch item-level discount info to show bundle names & savings per item
    if (typeof window.bndlr !== 'undefined' && typeof window.bndlr.getCheckoutInfo === 'function') {
      window.bndlr.getCheckoutInfo((data) => {
        if (data && data.items) {
          data.items.forEach(checkoutItem => {
            const itemKey = checkoutItem.key;
            const savings = checkoutItem.total_discount; // Item savings in cents

            if (savings > 0) {
              const itemSelector = `[data-b2b-discount-item-key="${itemKey}"]`;
              const discountRow = document.querySelector(itemSelector);
              if (discountRow) {
                discountRow.style.display = 'block';
                const savingsText = discountRow.querySelector('.item-b2b-savings-text');
                if (savingsText) {
                  savingsText.textContent = `Saved: -${formatCurrency(savings / 100)}`;
                }
              }
              
              // Also update the final price displayed for the item in cart
              const priceDisplay = document.querySelector(`[data-item-final-price-display="${itemKey}"]`);
              if (priceDisplay && checkoutItem.final_line_price) {
                priceDisplay.textContent = formatCurrency(checkoutItem.final_line_price / 100);
              }
            }
          });
        }
      });
    }
  });
}

/**
 * Currency formatter utility (Rupees/India local fallback)
 */
function formatCurrency(amount) {
  const formatter = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 2
  });
  
  // Format and replace space with standard spacing
  return formatter.format(amount).replace('INR', '₹');
}
